import DmaRepository from './DmaRepository';

export default class DmaService {
  private readonly dmaRepository: DmaRepository = new DmaRepository();

  async getDMAPolygonData(locationId: any) {
    try {
      return await this.dmaRepository.getDMAPolygonData(locationId);
    } catch (error) {
      console.error(error);
    }
  }

  async getDMADetailsData(
    dmaId: any,
    params?: { startDate?: string; endDate?: string },
  ) {
    try {
      return await this.dmaRepository.getDMADetailsData(dmaId, params);
    } catch (error) {
      console.error(error);
    }
  }

  async getDMAMnfAnalysis(
    dmaId: any,
    params?: { startDate?: string; endDate?: string },
  ) {
    try {
      return await this.dmaRepository.getDMAMnfAnalysis(dmaId, params);
    } catch (error) {
      console.error(error);
    }
  }
}
